import { HelmetProvider } from "react-helmet-async";
// import "../node_modules/react-toastify/dist/ReactToastify.css";
import { Toaster } from "./components/ui/toaster";
import ApplicationRoutes from "./routes/ApplicationRoutes";
import "./style/App.css";
import "@/components/HighlightLinks/style.css";
import { SpeechRecognitionProvider } from "./context/SpeechRecognitionContext";
import { SocialMediaHub } from "./components/SocialMediaHub";

function App() {
  return (
    <SpeechRecognitionProvider>
      <HelmetProvider>
        <Toaster />
        <ApplicationRoutes />
        <SocialMediaHub />
      </HelmetProvider>
    </SpeechRecognitionProvider>
  );
}

export default App;
